import React from 'react';

function ClientMessageOptionList (props) {
    const handleButtonClick = (e) => {
        props.sendMessage({type: "text", text: "領取訊號", data: "get"})
    }
    const optionDoms = props.optionList.map(x => 
        <div className="client-message-option"
             onClick={() => {
                props.sendMessage({type: "text", text: x, data: x})
             }}>{x}</div>
    )
    return (
        <div className="client-message-option-list">
            {optionDoms}
        </div>
    )
}

export default ClientMessageOptionList;